import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChainLink = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M19.054 6.32674C17.4593 4.7321 14.8739 4.7321 13.2793 6.32674L12.606 7.00018L13.6668 8.0607L14.34 7.38733C15.3488 6.37854 16.9845 6.37857 17.9933 7.3874L18.2793 7.67335C19.2881 8.68221 19.2881 10.3179 18.2793 11.3267L15.4933 14.1127C14.4845 15.1215 12.8488 15.1215 11.8399 14.1127L11.554 13.8267C11.1313 13.404 10.8864 12.8733 10.8175 12.3235L10.7243 11.5793L9.2359 11.7657L9.32913 12.5099C9.43798 13.3789 9.82663 14.2207 10.4933 14.8874L10.7793 15.1734C12.3739 16.768 14.9593 16.768 16.554 15.1734L19.3399 12.3874C20.9346 10.7928 20.9346 8.20733 19.3399 6.61269L19.054 6.32674Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2207 9.66011C11.6261 8.06547 9.04063 8.06547 7.44599 9.66011L4.66003 12.4461C3.06539 14.0407 3.06539 16.6261 4.66003 18.2208L4.94599 18.5067C6.54063 20.1014 9.12607 20.1013 10.7207 18.5067L11.394 17.8334L10.3333 16.7728L9.66001 17.4461C8.65116 18.4549 7.0155 18.4549 6.00665 17.4461L5.72069 17.1601C4.71184 16.1513 4.71184 14.5156 5.72069 13.5067L8.50665 10.7208C9.5155 9.71192 11.1512 9.71192 12.16 10.7208L12.446 11.0067C12.8687 11.4294 13.1136 11.9601 13.1825 12.51L13.2757 13.2542L14.764 13.0677L14.6708 12.3235C14.562 11.4546 14.1733 10.6127 13.5066 9.94607L13.2207 9.66011Z",
			fill: "currentColor"
		})
	]
});
export default SvgChainLink;
